import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Clock2 = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 23 23" width={size} height={size} color={iconColor} fill={iconColor}>
      <title>{iconTitle}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M11.5,21.5625 C17.0573653,21.5625 21.5625,17.0573653 21.5625,11.5 C21.5625,5.9426347 17.0573653,1.4375 11.5,1.4375 C5.9426347,1.4375 1.4375,5.9426347 1.4375,11.5 C1.4375,17.0573653 5.9426347,21.5625 11.5,21.5625 Z M23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 Z"
          fill={iconColor}
          fillRule="nonzero"
        />
        <path
          d="M10.668181,4 C11.0372072,4 11.336362,4.31624955 11.336362,4.70636315 L11.336362,12.0666672 L15.6768657,14.6886872 C15.9875728,14.8868349 16.0918946,15.3109125 15.9118628,15.6439714 C15.7318311,15.9770304 15.3332579,16.0973181 15.0140302,15.9149336 L10.3367632,13.089481 C10.1285894,12.9637737 10.0000773,12.7298 10,12.4763578 L10,4.70636315 C10,4.31624955 10.2991548,4 10.668181,4 Z"
          fill={iconColor}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

Clock2.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Clock2.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Clock2);
